import { render, staticRenderFns } from "./order_selffetch.vue?vue&type=template&id=41ac5dd2&scoped=true"
import script from "./order_selffetch.vue?vue&type=script&lang=js"
export * from "./order_selffetch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ac5dd2",
  null
  
)

export default component.exports